import React, {useEffect, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import DialogMUI from '../../../shared/DialogMUI';
import {closeModal} from '../../../redux/actions/app/appActions';
import {POPUPS} from '../../../redux/actions/app/appActionTypes';
import './ChangeDocStatus.scss';
import * as yup from 'yup';
import {Controller, useForm} from 'react-hook-form';
import {yupResolver} from '@hookform/resolvers/yup';
import {useTranslation} from 'react-i18next';
import {notifySuccess} from '../../../helpers/notifySnack';
import SelectComponent from "../../../shared/SelectComponent";
import ButtonMUI from "../../../shared/ButtonMUI";
import {changeDocStatus, getDocument, getDocuments} from "../../../redux/actions/documents/documentsActions";

const ChangeDocStatus = () => {
    const [submit, setSubmit] = useState(false);
    const popupToShow = useSelector(({app}) => app.popupToShow);
    const popupData = useSelector(({app}) => app.popupToShowData);
    const popupVisible = popupToShow === POPUPS.STATUS_DOC;
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const onCloseHandler = () => {
        dispatch(closeModal());
        setTimeout(() => {
            setSubmit(false);
            reset({
                status: ''
            })
        }, 150);
    };

    const schema = yup.object().shape({});

    const {
        handleSubmit,
        control,
        reset,
        formState: {isSubmitting, isValid}
    } = useForm({
        mode: 'all',
        reValidateMode: 'onChange',
        resolver: yupResolver(schema),
        defaultValues: {
            status: '',
        },
    });


    const onSubmit = async (data) => {

        setSubmit(true);

        const status = data.status === 'none' ? '' : data.status;
        try {
            const res = await dispatch(changeDocStatus(popupData.projectId,popupData.id, status));
            if (res.payload && res.payload.status === 202) {
                if(!popupData.isSinglePage){
                    await dispatch(getDocuments(popupData.projectId, 'document'));
                }
                else{
                    await dispatch(getDocument(popupData.projectId, popupData.id))
                    await dispatch(getDocuments(popupData.projectId, 'document'));
                }
                notifySuccess(t('all.successfully'));
            }
        } catch (err) {
            setSubmit(false);
            console.log(err);
        } finally {
            onCloseHandler();
        }
    };


    const options = [
        {
            id: 'none',
            name: t('all.withoutStatus'),
        },
        {
            id: 'partially_paid',
            name: t('all.partially_paid'),
        },
        {
            id: 'paid',
            name: t('all.paid'),
        },
    ]

    useEffect(() => {
        if(popupVisible){
            reset({
                status: popupData?.paymentStatus ?? 'none',
            })
        }
    }, [popupVisible]);
    return (
        <DialogMUI open={popupVisible} onClose={onCloseHandler} title={t('all.changeStatus')}>
            <div className='doc__modal'>
                <div className='doc__wrapper'>
                    <div className="doc__input">
                        <Controller
                            name='status'
                            control={control}
                            render={({field}) => (
                                <SelectComponent
                                    onChange={field.onChange}
                                    onBlur={field.onBlur}
                                    options={options}
                                    label={t('all.statusWord')}
                                    placeholder=''
                                    inputProps={field}
                                />
                            )}
                        />
                    </div>

                    <ButtonMUI
                        disabled={!isValid || isSubmitting || submit}
                        loading={isSubmitting}
                        onClick={handleSubmit(onSubmit)}
                        fullWidth={true}
                    >
                        {t('all.status')}
                    </ButtonMUI>
                </div>
            </div>
        </DialogMUI>
    );
};

export default ChangeDocStatus;
